<template>
  <v-card class="elevation-12">
    <v-toolbar
        color="primary"
        dark
        flat
    >
      <v-toolbar-title>{{ $t('loginPage.title') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-text-field
            :label="$t('loginPage.usernameLabel')"
            v-model="username"
            prepend-icon="mdi-account"
            type="text"
            :error-messages="usernameErrorMessages"
            @keyup.enter="onFormSubmit"
        ></v-text-field>

        <v-text-field
            v-model="password"
            :label="$t('loginPage.passwordLabel')"
            prepend-icon="mdi-lock"
            type="password"
            :error-messages="passwordErrorMessages"
            @keyup.enter="onFormSubmit"
        ></v-text-field>

        <v-snackbar v-model="isLoginFailed"
                    :timeout="5000"
                    :top="true"
                    color="error"
        >
          {{ $t('loginPage.loginFailed') }}
        </v-snackbar>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" :to="{name: 'register'}">{{ $t('loginPage.registerButton') }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" :disabled="isFormSuccess" @click="onLoginButtonClicked">{{ $t('loginPage.loginButton') }}</v-btn>
    </v-card-actions>

    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-footer app bottom flat padless color="primary" dark>
      <div class="row">
        <div class="col-12 elevation-12 text-center">
          {{ $t('loginPage.footer.systemInfo') }}
          <v-spacer></v-spacer>
          {{ $t('loginPage.footer.companyInfo') }}
        </div>
      </div>
    </v-footer>
  </v-card>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import {AUTH_REQUEST} from "../store/modules/auth/actions";
import {AUTH_FAILED} from "../events/auth";

export default {
  name: "LoginComponent",
  data() {
    return {
      username: '',
      password: '',

      isFormSuccess: false,
      isLoginFailed: false,
      isLoading: false
    };
  },
  validations: {
    username: {
      required
    },
    password: {
      required,
      // minLength: minLength(8),
    }
  },
  computed: {
    usernameErrorMessages() {
      const errors = [];
      if (this.$v.username.$dirty) {
        !this.$v.username.required && errors.push(this.$t('loginPage.errors.usernameRequired'));
      }
      return errors;
    },
    passwordErrorMessages() {
      const errors = [];
      if (this.$v.password.$dirty) {
        if (!this.$v.password.required) {
          errors.push(this.$t('loginPage.errors.passwordRequired'));
        }

        //todo: apply password min length after changing all passwords in production
        // else {
        //   if (!this.$v.password.minLength)
        //     errors.push('Пароль должен быть не менее 8 символов')
        // }
      }

      return errors;
    }
  },
  methods: {
    onLoginButtonClicked() {
      this.auth();
    },
    onFormSubmit() {
      this.auth();
    },

    auth() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isLoginFailed = false;

        this.isLoading = true;
        this.$store.dispatch(AUTH_REQUEST, {username: this.username, password: this.password})
      }
    },
    onAuthFailed() {
      this.isLoading = false;
      this.isLoginFailed = true;
    }
  },
  created() {
    this.$bus.$on(AUTH_FAILED, this.onAuthFailed)
  },
  beforeDestroy() {
    this.$bus.$off(AUTH_FAILED, this.onAuthFailed)
  }
}
</script>

<style scoped>

</style>